import {
	RouteLocationNormalized
} from 'vue-router'

// builds the page URL without its query string or hash, so values like emails or record IDs never reach GA
function pageLocationWithoutQuery(route: RouteLocationNormalized) {
	return `${window.location.origin}${route.path}`
}

// sends a GA page view for the given route, using the path only
export function trackPageView(route: RouteLocationNormalized) {
	if (typeof gtag !== 'function') return

	const pageDetails = {
		page_location: pageLocationWithoutQuery(route),
		page_title: document.title
	}

	// set first so any later automatic events on this page also report the stripped URL
	gtag('set', pageDetails)
	gtag('event', 'page_view', pageDetails)
}
